import { Button, Dialog, RadixDialogPrimitives, Typography } from '@capsule/consumer-design-system';

import { css } from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { LinkWithIcon } from './styles';

export const QuestionDialog = () => {
  const dispatchHowWeGotYourInformation = useSegmentEvent('viewHowWeGotYourInformation', { shouldTrackOnMount: false });

  return (
    <Dialog
      title="How did we get your medication information?"
      description="
      To support your treatment, we collaborate with doctors and other healthcare professionals and
      organizations. This collaboration may involve the exchange of health information with
      accordance with HIPAA. This enables us to deliver optimal care.
"
      triggerButton={
        <LinkWithIcon
          css={css`
            justify-content: start;
          `}
          onClick={() => {
            return dispatchHowWeGotYourInformation();
          }}
        >
          <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_info} />
          <Typography
            variant="small"
            css={css`
              margin-left: ${({ theme }) => theme.space.s2};
              position: relative;
              display: inline-block;
              bottom: ${({ theme }) => theme.space.s2};
            `}
          >
            Questions?
          </Typography>
        </LinkWithIcon>
      }
    >
      <RadixDialogPrimitives.Close asChild>
        <Button variant="outline-lg" isFullWidth>
          OK
        </Button>
      </RadixDialogPrimitives.Close>
    </Dialog>
  );
};
